window.addEventListener('DOMContentLoaded', function () {
  const blogPostHeader = document.querySelector('.c-blogpost-header');
  if (blogPostHeader) {
    resizeBlogPostHeader(blogPostHeader);
    const handleResizeThrottled = throttle(() => resizeBlogPostHeader(blogPostHeader), 300);
    window.addEventListener('resize', handleResizeThrottled);
  }

  if (document.body.classList.contains('neos-backend') || document.querySelector('.c-blogpost-header') == null) return;

  const tocContainer = document.querySelector('.blogpost-toc-container');
  const blogpostContent = document.querySelector('.blogpost-main-content');
  const lastContentSection = blogpostContent?.querySelector('section:last-child');
  const lastSectionPadding = window.getComputedStyle(lastContentSection)?.getPropertyValue('padding-bottom');
  const blogpostToc = document.querySelector('.blogpost-table-of-contents');

  if (!tocContainer) return;
  const headings = blogpostContent?.querySelectorAll('h2, h3');
  initToc(headings, tocContainer);

  if (blogpostToc && lastSectionPadding) {
    blogpostToc.style.marginBottom = lastSectionPadding;
  }
});

function resizeBlogPostHeader(header) {
  // Reset header height to auto to prevent jumping / wrong height calculation
  header.style.removeProperty('--header-height');

  if (window.innerWidth < 1024) return;

  const headerInfo = header.querySelector('.c-header-info');
  if (!headerInfo) return;

  // Calculate new header height
  const headerHeight = header.offsetHeight;
  const headerInfoHeightHalf = headerInfo.offsetHeight / 2;
  header.style.setProperty('--header-height', headerHeight - headerInfoHeightHalf + 'px');
}

function initToc(headings, headingContainer) {
  const ol = document.createElement('ol');

  headings.forEach((heading) => {
    heading.id = heading.innerText.toLowerCase();

    const li = document.createElement('li');
    const tocLink = document.createElement('a');

    switch (heading.tagName.toLowerCase()) {
      case 'h2':
        li.classList.add('c-table-h2');
        break;
      case 'h3':
        li.classList.add('c-table-h3');
        break;
    }

    tocLink.href = `#${heading.id}`;
    tocLink.textContent = heading.textContent;

    li.appendChild(tocLink);
    ol.appendChild(li);
  });

  headingContainer.appendChild(ol);
}

function throttle(fn, time) {
  let timeout = null;

  return function () {
    if (timeout) return;
    const context = this;
    const args = arguments;
    const later = () => {
      fn.call(context, ...args);
      timeout = null;
    }
    timeout = setTimeout(later, time);
  }
}
